import { c as _c } from "react/compiler-runtime";
import React, { Fragment } from 'react';
import { find as lodashFind } from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import ProductImage from 'components/consumer/cart/components/ProductImage';
import CtaButton from 'components/essentials/Cta/CtaButton';
import CtaLink from 'components/essentials/Cta/CtaLink';
import IconMaterialsDesigned from 'components/icons/iconMaterialsDesigned';
import IconPrint from 'components/icons/iconPrint';
import IconCard from 'components/icons/iconCard';
import IconProtectionPlan from 'components/icons/iconProtectionPlan';
import IconPetProtector from 'components/icons/iconPetProtector';
import IconDelivery from 'components/icons/iconDelivery';
import IconShipping from 'components/icons/iconShipping';
import IconHeart from 'components/icons/iconHeart3';
import IconHelp from 'components/icons/iconHelp';
import IconGuarantee from 'components/icons/iconGuarantee';
import { isOptionMaterial } from 'commons/constants';
import Currency from 'components/consumer/Currency';
import withLoginPage from 'components/consumer/consumer-login/login-page/hoc/withLoginPage';
import Link from 'components/consumer/Link';
import { getDelayedDeliveryTime } from '../../../withCheckoutUtils';
const OrderSuccessNew = props => {
  const $ = _c(98);
  const {
    orderId,
    orderSummary,
    shipping,
    payment,
    shippingGroups,
    deliveryInfo: t0,
    cartData
  } = props;
  const {
    production_selection,
    production_selection_add
  } = t0;
  const {
    grand_total,
    cart_subtotal,
    protectionSubtotal,
    base_discount_amount,
    total_shipping,
    tax_amount,
    gift_used,
    gift_card_rewards_used,
    discount
  } = orderSummary;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 data-xc="confirmation-title" className="mb-4 [&_svg]:w-[45px] [&_svg]:h-auto [&_svg]:mr-[15px] [&_svg]:relative [&_svg]:top-[5px] [&_svg]:max-[767px]:flex [&_svg]:max-[767px]:flex-1 [&_svg]:max-[767px]:w-auto [&_svg]:max-[767px]:mt-0 [&_svg]:max-[767px]:mx-auto [&_svg]:max-[767px]:mb-2.5 text-3xl font-bold md:flex md:items-center md:mb-3s"><IconMaterialsDesigned color="#6bb7bf" className="md:!static" />Congrats! Your order has been confirmed.</h1>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-[2.4rem] max-[767px]:mb-[1.2rem] [&_h1]:max-[767px]:text-center">{t1}<div className="max-[767px]:hidden"><CtaButton styling="link" color="brand" noLinkPadding={true} hasArrow={false} onClick={window.print} className="!p-0 md:!p-[unset] !mr-10"><IconPrint className="inline-block align-middle relative top-[-3px]" />Print</CtaButton></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 data-xc="order-number-heading" className="order-confirmation__box-header text-lg font-bold">Your Order Number</h2>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== orderId) {
    t4 = <div className="max-[767px]:mx-auto max-[767px]:my-0"><Link to="/customer/orders/" className="no-underline" prefetch={false}><div data-xc="order-number" className="max-[767px]:flex max-[767px]:mx-auto max-[767px]:my-0 bg-brand text-white pt-[.65rem] px-[1.3rem] pb-3 rounded text-2xl font-bold">{orderId}</div></Link></div>;
    $[3] = orderId;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="mt-[11px] text-gray max-[767px]:w-full max-[767px]:text-center text-xs">Please keep this number for your reference.</p>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <div className="flex flex-[1_0_50%] flex-col max-w-[315px] items-start mb-14 max-[767px]:flex-[1_1_100%] max-[767px]:max-w-none [&_h2]:first:max-[767px]:text-base [&_h2]:first:max-[767px]:border-0 [&_h2]:first:max-[767px]:font-bold [&_h2]:first:max-[767px]:text-center [&_h2]:first:max-[767px]:mb-0 [&:nth-child(3)]:mb-10 [&:nth-child(4)]:mb-10 [&_h2]:[border-bottom:1px_solid_#e5e5e5] [&_h2]:pb-2 [&_h2]:w-full [&_h2]:mb-4">{t3}{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="order-confirmation__box-header text-lg font-bold">Your Order Summary</h2>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-sm">Subtotal</span>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== cart_subtotal) {
    t9 = <div className="flex w-full justify-between my-[.45rem]">{t8}<Currency>{cart_subtotal}</Currency></div>;
    $[10] = cart_subtotal;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="text-sm">Shipping</span>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== total_shipping) {
    t11 = <div className="flex w-full justify-between my-[.45rem]">{t10}<Currency>{total_shipping}</Currency></div>;
    $[13] = total_shipping;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-sm">Tax</span>;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== tax_amount) {
    t13 = <div className="flex w-full justify-between my-[.45rem]">{t12}<Currency>{tax_amount}</Currency></div>;
    $[16] = tax_amount;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== protectionSubtotal) {
    t14 = protectionSubtotal > 0 && <div className="flex w-full justify-between my-[.45rem]"><span className="text-sm">Protection Plan</span><Currency>{protectionSubtotal}</Currency></div>;
    $[18] = protectionSubtotal;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== base_discount_amount || $[21] !== discount) {
    t15 = (base_discount_amount > 0 || discount > 0) && <div className="flex w-full justify-between my-[.45rem] text-red"><span className="text-sm">Discounts</span><span>- <Currency>{base_discount_amount || discount}</Currency></span></div>;
    $[20] = base_discount_amount;
    $[21] = discount;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== gift_used) {
    t16 = gift_used > 0 && <div className="flex w-full justify-between my-[.45rem] text-red"><span className="text-sm" data-xc="promo-code">Gift Card</span><span>- <Currency>{gift_used}</Currency></span></div>;
    $[23] = gift_used;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== gift_card_rewards_used) {
    t17 = gift_card_rewards_used > 0 && <div className="flex w-full justify-between my-[.45rem] text-red"><span className="text-sm" data-xc="credit">Credits</span><span>- <Currency>{gift_card_rewards_used}</Currency></span></div>;
    $[25] = gift_card_rewards_used;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="text-sm">Total</span>;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== grand_total) {
    t19 = <div className="flex w-full justify-between my-[.45rem] [&_span]:text-base [&_span]:font-bold">{t18}<Currency>{grand_total}</Currency></div>;
    $[28] = grand_total;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== t11 || $[31] !== t13 || $[32] !== t14 || $[33] !== t15 || $[34] !== t16 || $[35] !== t17 || $[36] !== t19 || $[37] !== t9) {
    t20 = <div className="flex flex-[1_0_50%] flex-col max-w-[315px] items-start mb-14 max-[767px]:flex-[1_1_100%] max-[767px]:max-w-none [&_h2]:first:max-[767px]:text-base [&_h2]:first:max-[767px]:border-0 [&_h2]:first:max-[767px]:font-bold [&_h2]:first:max-[767px]:text-center [&_h2]:first:max-[767px]:mb-0 [&:nth-child(3)]:mb-10 [&:nth-child(4)]:mb-10 [&_h2]:[border-bottom:1px_solid_#e5e5e5] [&_h2]:pb-2 [&_h2]:w-full [&_h2]:mb-4">{t7}{t9}{t11}{t13}{t14}{t15}{t16}{t17}{t19}</div>;
    $[30] = t11;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
    $[35] = t17;
    $[36] = t19;
    $[37] = t9;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <h2 className="order-confirmation__box-header text-lg font-bold">Payment Information</h2>;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== orderSummary.grand_total || $[41] !== payment.credit_cards || $[42] !== payment.selected_type) {
    t22 = payment.selected_type === "credit_card" && payment.credit_cards.map(creditCard => {
      const amount = payment.credit_cards.length > 1 ? creditCard.amount : orderSummary.grand_total;
      return <span className="pl-10 relative mb-[22px] [&_svg]:top-[3px] [&_svg]:left-0 [&_svg]:absolute"><IconCard /><span className="max-w-[180px] block leading-[1.4em] text-sm"><Currency>{typeof amount === "string" ? amount.replace(",", "") : amount}</Currency>{creditCard.number && ` charged to card ending in ${creditCard.number.slice(-4)}`}</span></span>;
    });
    $[40] = orderSummary.grand_total;
    $[41] = payment.credit_cards;
    $[42] = payment.selected_type;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== orderSummary.grand_total || $[45] !== payment.selected_type) {
    t23 = payment.selected_type === "affirm" && <span className="pl-10 relative mb-[22px] [&_svg]:top-[3px] [&_svg]:left-0 [&_svg]:absolute"><IconCard /><span className="max-w-[180px] block leading-[1.4em] text-sm"><Currency>{orderSummary.grand_total}</Currency> charged to Affirm</span></span>;
    $[44] = orderSummary.grand_total;
    $[45] = payment.selected_type;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== orderSummary.grand_total || $[48] !== payment.selected_type) {
    t24 = payment.selected_type === "apple_pay" && <span className="pl-10 relative mb-[22px] [&_svg]:top-[3px] [&_svg]:left-0 [&_svg]:absolute"><IconCard /><span className="max-w-[180px] block leading-[1.4em] text-sm"><Currency>{orderSummary.grand_total}</Currency> charged to Apple Pay</span></span>;
    $[47] = orderSummary.grand_total;
    $[48] = payment.selected_type;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== orderSummary.grand_total || $[51] !== payment.selected_type) {
    t25 = payment.selected_type === "paypal" && <span className="pl-10 relative mb-[22px] [&_svg]:top-[3px] [&_svg]:left-0 [&_svg]:absolute"><IconCard /><span className="max-w-[180px] block leading-[1.4em] text-sm"><Currency>{orderSummary.grand_total}</Currency> charged to PayPal</span></span>;
    $[50] = orderSummary.grand_total;
    $[51] = payment.selected_type;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t22 || $[54] !== t23 || $[55] !== t24 || $[56] !== t25) {
    t26 = <div className="flex flex-[1_0_50%] flex-col max-w-[315px] items-start mb-14 max-[767px]:flex-[1_1_100%] max-[767px]:max-w-none [&_h2]:first:max-[767px]:text-base [&_h2]:first:max-[767px]:border-0 [&_h2]:first:max-[767px]:font-bold [&_h2]:first:max-[767px]:text-center [&_h2]:first:max-[767px]:mb-0 [&:nth-child(3)]:mb-10 [&:nth-child(4)]:mb-10 [&_h2]:[border-bottom:1px_solid_#e5e5e5] [&_h2]:pb-2 [&_h2]:w-full [&_h2]:mb-4">{t21}<div className="flex flex-col pt-1.5">{t22}{t23}{t24}{t25}</div></div>;
    $[53] = t22;
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <h2 className="order-confirmation__box-header text-lg font-bold">Shipping Address</h2>;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <br />;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== shipping.apartment) {
    t29 = shipping.apartment && <><br /> {shipping.apartment}</>;
    $[60] = shipping.apartment;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <br />;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== shipping.address || $[64] !== shipping.city || $[65] !== shipping.first_name || $[66] !== shipping.last_name || $[67] !== shipping.state || $[68] !== shipping.zipcode || $[69] !== t29) {
    t31 = <div className="flex flex-[1_0_50%] flex-col max-w-[315px] items-start mb-14 max-[767px]:flex-[1_1_100%] max-[767px]:max-w-none [&_h2]:first:max-[767px]:text-base [&_h2]:first:max-[767px]:border-0 [&_h2]:first:max-[767px]:font-bold [&_h2]:first:max-[767px]:text-center [&_h2]:first:max-[767px]:mb-0 [&:nth-child(3)]:mb-10 [&:nth-child(4)]:mb-10 [&_h2]:[border-bottom:1px_solid_#e5e5e5] [&_h2]:pb-2 [&_h2]:w-full [&_h2]:mb-4">{t27}<p className="leading-[1.5em] text-sm">{shipping.first_name} {shipping.last_name}{t28} {shipping.address}{t29}{t30}{shipping.city}, {shipping.state} {shipping.zipcode}</p></div>;
    $[63] = shipping.address;
    $[64] = shipping.city;
    $[65] = shipping.first_name;
    $[66] = shipping.last_name;
    $[67] = shipping.state;
    $[68] = shipping.zipcode;
    $[69] = t29;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t20 || $[72] !== t26 || $[73] !== t31 || $[74] !== t6) {
    t32 = <div className="flex flex-wrap justify-between flex-row">{t6}{t20}{t26}{t31}</div>;
    $[71] = t20;
    $[72] = t26;
    $[73] = t31;
    $[74] = t6;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  let t33;
  if ($[76] !== cartData || $[77] !== production_selection || $[78] !== production_selection_add || $[79] !== shippingGroups) {
    let t34;
    if ($[81] !== cartData || $[82] !== production_selection || $[83] !== production_selection_add || $[84] !== shippingGroups.length) {
      t34 = (group, groupIndex) => <Fragment key={group.id}><h2 className="text-2xl font-bold">Shipment {groupIndex + 1} of {shippingGroups.length}</h2>{group.cart.map(cartItem => {
          const estimated_delivery = cartItem.estimated_delivery || "TBD";
          const estimated_delivery_title = cartItem.estimated_delivery_title || "";
          const item = {
            ...cartItem
          };
          const cartProduct = lodashFind(cartData, {
            id: item.id
          });
          if (cartProduct) {
            item.imageURL = cartProduct.imageURL;
            item.product = cartProduct.product;
            item.selected_protection_plan = cartProduct.selected_protection_plan;
          }
          return <div className="flex flex-wrap [border-bottom:1px_solid_#f6f6f6] pb-[3.25rem] mb-[3.25rem] last:[border-bottom:0] last:mb-0 [&_h2]:flex-[1_1_100%] [&_h2]:mb-4" key={item.id}><ProductImage containerClass="flex-[1_1_50%] bg-gray-light8 rounded-lg h-[300px] flex items-center justify-center w-full px-0 py-10 max-[767px]:flex-[1_1_100%] max-[767px]:h-[235px] max-[767px]:mb-8 [&_img]:h-3/4 [&_img]:w-auto" product={item} width={500} trim="color" trimPad={20} /><div className="flex-[1_1_50%] pl-[29px] max-[767px]:pl-0"><div className="[border-bottom:1px_solid_#f6f6f6] pb-3.5"><h3 className="mb-[5px] text-xl font-bold">{item.name}</h3><Currency className="text-xs font-bold">{item.price}</Currency>{item.total_cost > 0 && <Currency className={cx("text-xs font-bold", {
                  "line-through": item.discounted_cost
                })}>{item.total_cost}</Currency>}{item.discounted_cost && <Currency className="text-xs font-bold ml-[.3rem] text-red">{item.discounted_cost}</Currency>}<span className="ml-2.5 text-xs">QTY: {item.quantity}</span></div>{item.selected_protection_plan && item.selected_protection_plan.plan_id && <div className="pt-[13px] pr-0 pb-0 pl-[60px] relative [border-bottom:1px_solid_#f6f6f6] [&_p]:text-gray [&_p]:mb-0 [&_svg]:absolute [&_svg]:left-0 [&_svg]:top-4 [&_h4]:mb-0">{item.selected_protection_plan.plan_name.includes("Pet") ? <IconPetProtector /> : <IconProtectionPlan />}<h4>5-Year Protection Plan</h4><p className="text-xs">Purchased {item.selected_protection_plan.plan_name}{" "}for{" "}<Currency>{item.selected_protection_plan.plan_price}</Currency></p><CtaLink target="_blank" to="/furniture-protection-plan/" styling="link" noLinkPadding={true} color="brand" hasArrow={false} className="!p-0 md:!p-[unset] [&_span]:!text-xs [&_span]:!font-bold">Details</CtaLink></div>}<div className="flex flex-wrap pt-[1.2rem]"><div className="flex-[1_1_40%] [&:nth-child(2)]:pl-[35px]">{item.options && item.options.length > 0 && <div className="flex-[1_0_50%] flex flex-col mb-7"><span className="text-gray mb-[3px] text-xs">Customizations</span><span className="order-confirmation__text text-xs">{item.options.map(option => <Fragment key={option.id}><span>{item.pickLater && isOptionMaterial[option.optionTypeId] ? "Material: Decide Later" : option.optionTypeId === 133 && option.name === "Not included" ? null : option.optionTypeId === 135 ? null : `${option.optionTypeName}: ${option.name}`}</span><br /></Fragment>)}</span></div>}{!!item.attributes_min?.dimensions && item.product?.type?.name !== "Bed" && <div className="flex-[1_0_50%] flex flex-col mb-7"><span className="text-gray mb-[3px] text-xs">Size</span><span className="order-confirmation__text text-xs">{item.attributes_min.dimensions}</span></div>}</div><div className="flex-[1_1_40%] [&:nth-child(2)]:pl-[35px]">{estimated_delivery_title && <div className="flex-[1_0_50%] flex flex-col mb-7"><span className="text-gray mb-[3px] text-xs">{estimated_delivery_title}</span><span className="order-confirmation__text text-xs">{item.pickLater ? "Arrival time can't be estimated until final fabric selection is made" : production_selection[group.id] === "delayed_shipping" ? getDelayedDeliveryTime(production_selection_add[group.id]) : estimated_delivery}</span></div>}</div></div></div></div>;
        })}</Fragment>;
      $[81] = cartData;
      $[82] = production_selection;
      $[83] = production_selection_add;
      $[84] = shippingGroups.length;
      $[85] = t34;
    } else {
      t34 = $[85];
    }
    t33 = shippingGroups.map(t34);
    $[76] = cartData;
    $[77] = production_selection;
    $[78] = production_selection_add;
    $[79] = shippingGroups;
    $[80] = t33;
  } else {
    t33 = $[80];
  }
  let t34;
  if ($[86] !== t32 || $[87] !== t33) {
    t34 = <div className="order-confirmation my-8 w-full !max-w-[843px] mt-0 mx-auto mb-12 p-20 !bg-white text-gray rounded max-[767px]:px-4 max-[767px]:py-[2.2rem]">{t2}{t32}{t33}</div>;
    $[86] = t32;
    $[87] = t33;
    $[88] = t34;
  } else {
    t34 = $[88];
  }
  let t35;
  let t36;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <h1 className="relative p-2.5 after:[content:''] after:w-10 after:h-0.5 after:bg-brand after:absolute after:-top-2.5 after:left-1/2 after:-ml-5 text-3xl font-bold">Things are about to get exciting</h1>;
    t36 = <p className="max-[700px] mx-auto my-0">Get prepared for your new furniture by checking out these helpful resources to ensure a hassle-free delivery and a seamless fit in your space.</p>;
    $[89] = t35;
    $[90] = t36;
  } else {
    t35 = $[89];
    t36 = $[90];
  }
  let t37;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="flex-[1_1_30%] mb-28 px-8 py-0 max-[1023px]:p-4 max-[767px]:flex-[1_1_100%] max-[767px]:mb-8 [&_h3]:mt-8 [&_svg]:[&:nth-child(2)]:-mt-5 [&_svg]:[&:nth-child(3)]:-mt-2.5"><IconDelivery className="mx-auto my-0" /><h3 className="text-xl font-bold">Measuring for Delivery</h3><p>It's important to measure and double check the space you're planning on putting your furniture in to ensure a smooth delivery process</p><CtaLink className="!p-0 md:!p-[unset]" to="/fit-guide" styling="link" color="brand">See our Fit Guide</CtaLink></div>;
    $[91] = t37;
  } else {
    t37 = $[91];
  }
  let t38;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <div className="flex-[1_1_30%] mb-28 px-8 py-0 max-[1023px]:p-4 max-[767px]:flex-[1_1_100%] max-[767px]:mb-8 [&_h3]:mt-8 [&_svg]:[&:nth-child(2)]:-mt-5 [&_svg]:[&:nth-child(3)]:-mt-2.5"><IconShipping className="mx-auto my-0" /><h3 className="text-xl font-bold">What to Expect for Shipping</h3><p>Cue the trumpets, today's the day your Joybird furniture arrives! Check out this helpful information to ensure a smooth delivery</p><CtaLink className="!p-0 md:!p-[unset]" to="/shipping-and-delivery" styling="link" color="brand">Find out more</CtaLink></div>;
    $[92] = t38;
  } else {
    t38 = $[92];
  }
  let t39;
  if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <div className="flex-[1_1_30%] mb-28 px-8 py-0 max-[1023px]:p-4 max-[767px]:flex-[1_1_100%] max-[767px]:mb-8 [&_h3]:mt-8 [&_svg]:[&:nth-child(2)]:-mt-5 [&_svg]:[&:nth-child(3)]:-mt-2.5"><IconHeart className="mx-auto my-0" /><h3 className="text-xl font-bold">Caring for your furniture</h3><p>Keep your furniture looking as the day it arrived. Learn what cleaning method is recommended for your fabric, wood, or leather.</p><CtaLink className="!p-0 md:!p-[unset]" to="/product-care" styling="link" color="brand">Learn About Product Care</CtaLink></div>;
    $[93] = t39;
  } else {
    t39 = $[93];
  }
  let t40;
  if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <div className="flex-[1_1_30%] mb-28 px-8 py-0 max-[1023px]:p-4 max-[767px]:flex-[1_1_100%] max-[767px]:mb-8 [&_h3]:mt-8 [&_svg]:[&:nth-child(2)]:-mt-5 [&_svg]:[&:nth-child(3)]:-mt-2.5"><IconGuarantee className="mx-auto my-0" /><h3 className="text-xl font-bold">Our Warranty</h3><p>We deliver what we promise, which is meeting your specific design needs, unparalleled value, and a personalised shopping experience.</p><CtaLink className="!p-0 md:!p-[unset]" to="/warranty/" styling="link" color="brand">Warranty Details</CtaLink></div>;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  let t41;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <div className="bg-white text-center mb-16 pt-32 px-8 pb-8 max-[767px]:px-4 max-[767px]:py-8">{t35}{t36}<div className="flex flex-wrap mt-[4.5rem] mx-auto mb-0 px-8 py-0 max-[1400px] w-full max-[767px]:mt-8 max-[767px]:mx-auto max-[767px]:mb-0">{t37}{t38}{t39}{t40}<div className="flex-[1_1_30%] mb-28 px-8 py-0 max-[1023px]:p-4 max-[767px]:flex-[1_1_100%] max-[767px]:mb-8 [&_h3]:mt-8 [&_svg]:[&:nth-child(2)]:-mt-5 [&_svg]:[&:nth-child(3)]:-mt-2.5"><IconHelp className="mx-auto my-0" /><h3 className="text-xl font-bold">Need more help?</h3><p>We're here for you even after your order. Feel free to chat or give us a call, chat, or text us. You can also view our FAQ page.</p><CtaLink className="!p-0 md:!p-[unset]" to="https://help.joybird.com/hc/en-us" styling="link" color="brand">Read FAQs</CtaLink></div></div></div>;
    $[95] = t41;
  } else {
    t41 = $[95];
  }
  let t42;
  if ($[96] !== t34) {
    t42 = <div className="bg-gray-light8 pt-4">{t34}{t41}</div>;
    $[96] = t34;
    $[97] = t42;
  } else {
    t42 = $[97];
  }
  return t42;
};
OrderSuccessNew.propTypes = {
  cartData: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      product: PropTypes.shape({
        name: PropTypes.string,
        type: PropTypes.shape({
          name: PropTypes.string
        })
      }),
      attributes_min: PropTypes.shape({
        dimensions: PropTypes.string
      }),
      options: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        optionTypeId: PropTypes.number,
        optionTypeName: PropTypes.string
      }))
    }))
  }),
  deliveryInfo: PropTypes.shape({
    production_selection: PropTypes.shape({
      [PropTypes.string]: PropTypes.string
    }),
    production_selection_add: PropTypes.shape({
      [PropTypes.string]: PropTypes.string
    })
  }),
  orderId: PropTypes.string,
  orderSummary: PropTypes.shape({
    base_discount_amount: PropTypes.number,
    cart_subtotal: PropTypes.number,
    discount: PropTypes.number,
    gift_card_rewards_used: PropTypes.number,
    gift_used: PropTypes.number,
    grand_total: PropTypes.number,
    protectionSubtotal: PropTypes.number,
    tax_amount: PropTypes.number,
    total_shipping: PropTypes.number
  }),
  payment: PropTypes.shape({
    credit_cards: PropTypes.arrayOf(PropTypes.shape({
      card_type: PropTypes.string,
      last_four: PropTypes.string
    })),
    method: PropTypes.shape({
      name: PropTypes.string
    }),
    selected_type: PropTypes.string
  }),
  shipping: PropTypes.object,
  shippingGroups: PropTypes.arrayOf(PropTypes.shape({
    cart: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({
        product: PropTypes.shape({
          name: PropTypes.string,
          type: PropTypes.shape({
            name: PropTypes.string
          })
        }),
        attributes_min: PropTypes.shape({
          dimensions: PropTypes.string
        }),
        options: PropTypes.arrayOf(PropTypes.shape({
          name: PropTypes.string,
          optionTypeId: PropTypes.number,
          optionTypeName: PropTypes.string
        }))
      }))
    })
  }))
};
export const OrderSuccessNewAuth = withLoginPage(OrderSuccessNew);
export default OrderSuccessNew;